/**
 * orga-app-api - api-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { MandantConfigRequest } from '../model/mandantConfigRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class MandantVerwaltungService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * GetMandantConfig
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin) 
     * @endpoint get /api/mandanten/verwaltung/v1/config
     * @param keys 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getMandantConfig(keys?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: any; }>;
    public getMandantConfig(keys?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: any; }>>;
    public getMandantConfig(keys?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: any; }>>;
    public getMandantConfig(keys?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new OpenApiHttpParams(this.encoder);

        localVarQueryParameters = this.addToHttpParams(
            localVarQueryParameters,
            'keys',
            <any>keys,
            QueryParamStyle.Form,
            true,
        );


        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/mandanten/verwaltung/v1/config`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: any; }>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters.toHttpParams(),
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * GetMandantConfigDownload
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin) 
     * @endpoint get /api/mandanten/verwaltung/v1/config/download
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public getMandantConfigDownload(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<{ [key: string]: any; }>;
    public getMandantConfigDownload(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<{ [key: string]: any; }>>;
    public getMandantConfigDownload(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<{ [key: string]: any; }>>;
    public getMandantConfigDownload(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/mandanten/verwaltung/v1/config/download`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<{ [key: string]: any; }>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

    /**
     * PostMandantConfigSpeichern
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin)  ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeinMandantOderTechAdmin: (KeinMandantAdminOderTechAdmin) 
     * @endpoint post /api/mandanten/verwaltung/v1/config/speichern
     * @param mandantConfigRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postMandantConfigSpeichern(mandantConfigRequest: MandantConfigRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<string>;
    public postMandantConfigSpeichern(mandantConfigRequest: MandantConfigRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<string>>;
    public postMandantConfigSpeichern(mandantConfigRequest: MandantConfigRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<string>>;
    public postMandantConfigSpeichern(mandantConfigRequest: MandantConfigRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (mandantConfigRequest === null || mandantConfigRequest === undefined) {
            throw new Error('Required parameter mandantConfigRequest was null or undefined when calling postMandantConfigSpeichern.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/mandanten/verwaltung/v1/config/speichern`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<string>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: mandantConfigRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
